<template>
  <div class="ce-searchFilter-color">
    <label>{{ label }}</label>
    <div class="flex flex-wrap mxn1">
      <ColorSpaceBadge
        interactive
        with-tooltip
        with-shadow
        v-for="color in options"
        :key="color.code"
        :color="color"
        @toggle="toggle(color)" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SearchConfig from '@sun-chemical/system-config/search-config';
import { cloneObject, sortArray } from 'utils';
import ColorSpaceBadge from 'components/ColorSpaceBadge.vue';

export default {
  props: {
    colors: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    filterKey: {
      type: String,
      required: false,
      default: null
    },
  },
  components: { ColorSpaceBadge },
  computed: {
    ...mapState(['fieldManifest']),
    ...mapGetters(['urlFilters']),
    manifest() {
      return this.fieldManifest.color_space;
    },
    options() {
      return sortArray(
        this.colors
          .map((c) => {
            const colorConfig = this.manifest.optionsConfig.find((r) => r.code === c.code);

            return {
              ...c,
              ...colorConfig,
            };
          }),
        'sort'
      );
    },
  },
  methods: {
    toggle(color) {
      if (color.disabled) return;
      const colors = cloneObject(this.colors);
      const toChange = colors.find((c) => c.code === color.code);
      toChange.selected = !toChange.selected;

      this.$trackEvent('filter', 'toggle', {
        filterType: 'color',
        filterKey: this.filterKey,
        filterLabel: this.label,
        value: color.code
      });

      const activeColors = colors.filter((c) => c.selected).map((c) => c.code);

      const url = cloneObject(this.urlFilters);
      const { param } = SearchConfig.getMap().color_space;

      if (activeColors.length > 0) url[param] = activeColors;
      else delete url[param];

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>
